import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      marginTop: 40,
      marginLeft: "5%",
      width: "90%",
      textTransform: "uppercase",
      borderRadius: 10,
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        color: "#3db0e2 !important",
        backgroundColor: "#fff"
      }
    },
    itemText: {
      fontSize: 12,
      fontWeight: "bold",
      "&:hover": {
        color: "#3db0e2 !important"
      }
    },
    button: (props: any) => ({
      position: props.position,
      bottom: 20,
      width: 120,
      height: 50,
      backgroundColor: "#fff",
      color: "#000",
      "&:hover": {
        color: "#fff !important",
        backgroundColor: theme.palette.primary.main
      },
      cursor: "pointer",
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: "14px"
    }),
    buttonDesktop: {
      left: "13vw"
    },
    buttonMobile: {
      left: "2vw"
    }
  })
);
interface IProps {
  onClick: () => void;
  position?: string;
}

const BackButton: React.FC<IProps> = ({ onClick, position = "fixed" }: IProps) => {
  const classes = useStyles({ position });
  return (
    <>
      <Hidden mdDown>
        <button className={`${classes.button} ${position === "fixed" ? classes.buttonDesktop : classes.buttonMobile}`} onClick={onClick}>
          Wstecz
        </button>
      </Hidden>
      <Hidden lgUp>
        <button className={`${classes.button} ${classes.buttonMobile}`} onClick={onClick}>
          Wstecz
        </button>
      </Hidden>
    </>
  );
};

export default BackButton;
